(function () {
    'use strict';

    angular.module("imApp").factory("oeeStateEquipmentsService", ['$ihttp', function ($ihttp) {
        let service = {
            listEquipments: function (parms) {
                return $ihttp.post({
                    method: 243,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
